import type { InsertPointOnSegment } from "./types";

// Segment i connects points[i] to points[(i + 1) % length]; inserting after i
// works for the implicit closing segment as well (splice at length appends).
export const insertPointOnSegment: InsertPointOnSegment = ({
  points,
  segmentIndex,
  position,
}) => {
  const updatedPoints = [...points];
  updatedPoints.splice(segmentIndex + 1, 0, position);
  return { points: updatedPoints, newIndex: segmentIndex + 1 };
};
